export default "/images/c_rank.webp?ccf6c027c7f032afc0d071eae2ce1e50";